import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { GetServiceCaller, PostServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { toast } from "react-toastify";

const KnowledgeBaseAdmin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("KB Admin"));
  }, []);

  const columns = {
    UploadedDate: { text: "Date Uploaded ", align: "center", visible: true, },
    UploadedBy: { text: "Employee", align: "start", visible: true },
    Name: { text: "Title", align: "start", visible: true },
    Category: { text: "Category", align: "start", visible: true },
    Domain: { text: "Domain", align: "start", visible: true },
    FileType: {
      text: "File Type",
      align: "start",
      type: "HTML",
      visible: true,
    },
    Status_123: {
      text: "Status",
      align: "start",
      type: "HTML",
      visible: true,
    },
  };
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [searchTerm, setSearchTerm] = useState("");
  const [kbAdminListdata, setKbAdminListdata] = useState([]);
  const [empOptions, setEmpOptions] = useState([]);
  const [domainOptions, setDomainOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);


  useEffect(() => {
    fetchProjectListingData();
  }, []);
  const fetchProjectListingData = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}nest/dashboard/knowledge-base-admin?contactid=&searchString=&domain_150=&documentCategory_151=&applicationStatus_123=&p_Offset=`
      );
      setKbAdminListdata([])
      SetApiStatus(response?.status);
      if (response?.status === 200) {
        const cleanedData = response?.data?.data;
        setKbAdminListdata(cleanedData?.data);

        const catOPt = cleanedData?.category?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setCategoryOptions(catOPt);
        const employees = cleanedData?.employeeList?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setEmpOptions(employees);
        const domain = cleanedData?.domainList?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setDomainOptions(domain);
        const statOpt = cleanedData?.status?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setStatusOptions(statOpt);
      } else {
        console.error(
          "Failed to fetch asset categories. Server responded with status:",
          response
        );
      }
    } catch (error) {
      console.error("Knowledge Base Admin  API Error:", error);
    }
  };

  const formDatas = [
    {
      name: "Employee",
      type: "Select",
      options: [...empOptions],
    },
    {
      name: "Title",
      type: "Text",
      //   options: [[]],
    },
    {
      name: "Domain",
      type: "Select",
      options: [...domainOptions],
    },
    {
      name: "Category",
      type: "Select",
      options: [...categoryOptions],
    },
    {
      name: "Status",
      type: "Select",
      options: [...statusOptions],
    },
  ];

  const handleGetData = async () => {
    SetApiStatus(undefined)
    setKbAdminListdata([])
    try {
      const response = await GetServiceCaller(
        `${API_URL}nest/dashboard/knowledge-base-admin?contactid=${filterFormData.find((o) => o.label === "Employee")
          ? filterFormData.find((o) => o.label === "Employee").value
          : 0
        }&searchString=${filterFormData.find((o) => o.label === "Title")
          ? filterFormData.find((o) => o.label === "Title").value
          : ""
        }&domain_150=${filterFormData.find((o) => o.label === "Domain")
          ? filterFormData.find((o) => o.label === "Domain").value
          : 0
        }&documentCategory_151=${filterFormData.find((o) => o.label === "Category")
          ? filterFormData.find((o) => o.label === "Category").value
          : 0
        }&applicationStatus_123=${filterFormData.find((o) => o.label === "Status")
          ? filterFormData.find((o) => o.label === "Status").value
          : 0
        }&p_Offset=`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.data;

        setKbAdminListdata(cleanedData)
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };



  const [filterFormData, setFilterData] = useState([]);

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };
  const handleViewPDF = (item) => {
    if (item?.FilePath) {
      window.open(item.FilePath, '_blank');
    } else {
      console.error("No PDF path found.");
    }
  };


  const handleApprove = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleReject = (item) => {
    setSelectedItem(item);
    setRejectModal(true);
  };

  const knowledgeStatus = (status, remark) => {
    if (!selectedItem) return;

    PostServiceCaller(
      `${API_URL}nest/dashboard/knowledge-base-admin/${selectedItem.ID}`,
      {
        kb_appstatus: status,
        Remarks: remark || "", // optional remark
      },
      "put"
    )
      .then((response) => {
        if (status === 826) {
          toast.success("Knowledge Base Approved Successfully!");
        } else if (status === 827) {
          toast.success("Knowledge Base Rejected Successfully!");
        }
        fetchProjectListingData();
        setShowModal(false);
        setRejectModal(false);
        setSelectedItem(null);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleApproveSubmit = (e) => {
    e.preventDefault();
    const remark = e.target.Remark.value;
    knowledgeStatus(826, remark);
  };

  const handleRejectSubmit = (e) => {
    e.preventDefault();
    const remark = e.target.Remark.value;
    knowledgeStatus(827, remark);
  };





  const handleReset = () => {
    setFilterData([]);
    fetchProjectListingData()
  };




  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={kbAdminListdata}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              handleChange={handleChange}
              filterFormData={filterFormData}
              isSorting={true}
              handleGetData={handleGetData}
              formDatas={formDatas}
              showIcon1={true}
              showIcon2={true}
              handleReset={handleReset}
              showIcon3={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              showIcon4={false}
              showIcon5={false}
              isActionRequired={true}
              isAddNewBtnRequired={false}
              handleIcon1={handleViewPDF}
              handleIcon2={handleApprove}
              handleIcon3={handleReject}
              icons={{
                Icon1: <i class="bi bi-eye-fill icons"></i>,
                Icon1Text: " View",
                Icon2: <i className="fa fa-check"></i>,
                Icon2Text: " Approve",
                Icon2Flag: "Enable",
                Icon3: <i className="fa fa-close"></i>,
                Icon3Text: " Reject",
                Icon3Flag: "Enable",
                Icon4: <i className="bi bi-trash icons"></i>,
                Icon4Text: " Reject",
              }}
            />
          </div>
        </div>
        {showModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1050
            }}
          >
            <div
              className="modal-dialog modal-sm"
              role="document"
              style={{
                width: "300px", // Standard width for modal-sm
                margin: 0 // Remove default margin
              }}
            >
              <div className="modal-content">
                <div className="modal-header" style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  borderBottom: '1px solid #f0f0f0',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px 8px 0 0'
                }}>
                  <p style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#27568B',
                    margin: '0'
                  }}>Approve</p>
                  <button
                    onClick={() => setShowModal(false)}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '18px',
                      color: '#000',
                      padding: '4px',
                      borderRadius: '4px',
                      transition: 'all 0.2s',
                      lineHeight: '1'
                    }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>
                <div className="modal-body p-2">
                  <form onSubmit={handleApproveSubmit}>
                    <div className="row">
                      <div className="col-md-12">
                        <textarea
                          type="text"
                          className="form-control"
                          id="Remark"
                          aria-describedby="Remark"
                          name="Remark"
                          placeholder="Remark"
                        />
                      </div>
                    </div>
                    <div className="text-end mt-4">
                      <button
                        type="button"
                        className="cancel-btn-sm me-2"
                        onClick={() => setShowModal(false)}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="custom-btn-sm">
                        Approve
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* reject model */}
        {rejectModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1050
            }}
          >
            <div
              className="modal-dialog modal-sm"
              role="document"
              style={{
                width: "300px",
                margin: 0
              }}
            >
              <div className="modal-content">
                <div className="modal-header" style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  borderBottom: '1px solid #f0f0f0',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px 8px 0 0'
                }}>
                  <p style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#27568B',
                    margin: '0'
                  }}>Reject</p>
                  <button
                    onClick={() => setRejectModal(false)}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '18px',
                      color: '#000',
                      padding: '4px',
                      borderRadius: '4px',
                      transition: 'all 0.2s',
                      lineHeight: '1'
                    }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>
                <div className="modal-body p-2">
                  <form onSubmit={handleRejectSubmit}>
                    <div className="row">
                      <div className="col-md-12">
                        <textarea
                          type="text"
                          className="form-control"
                          id="Remark"
                          aria-describedby="Remark"
                          name="Remark"
                          placeholder="Remark"
                        />
                      </div>
                    </div>
                    <div className="text-end mt-4">
                      <button
                        type="button"
                        className="cancel-btn-sm me-2"
                        onClick={() => setRejectModal(false)}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="custom-btn-sm">
                        Reject
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default KnowledgeBaseAdmin;
